<template>
    <div class="communication-page">
      功能待开发
    </div>
</template>

<script>
export default {
  name: 'RecruitCommunicate'
}
</script>

<style scoped>
.communication-page {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit/RecruitCommunicate.vue